import {
  IonAlert,
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonLoading,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import { home } from 'ionicons/icons'
import React, { useState } from 'react'
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import EigenheimSteps from "../../components/eigenheim.steps"
import Note from "../../components/note"
import { multilevelFallback } from '../../lib/multilevel.fallback'
import { State } from '../../store'
import { addNotification, addNotificationType } from '../../store/notification'
import { setAddress, setAddressType } from "../../store/quote"

interface StateProps {
  decoded: any
  address: any
}

interface DispatchProps {
  setAddress: setAddressType
  addNotification: addNotificationType
}

type Props = RouteComponentProps<{}> & StateProps & DispatchProps

const Address: React.FC<Props> = (props) => {
  React.useEffect(() => {
    if (!props.decoded) {
      props.history.push({ pathname: '/home' })
    }
  }, [props.decoded])

  const [nextConfirm, setNextConfirm] = useState(false)
  const [showLoading, setShowLoading] = useState(false);

  const fallback = multilevelFallback([props.address, props.decoded.address])

  const [street, setStreet] = useState(fallback('street'));
  const [house, setHouse] = useState(fallback('house'));
  const [stairs, setStairs] = useState(fallback('stairs'));
  const [door, setDoor] = useState(fallback('door'));
  const [zipCode, setZipCode] = useState(fallback('zipcode'));
  const [city, setCity] = useState(fallback('city'));
  const [gstnr, setGstnr] = useState(fallback('riskAddress', 'gstnr'));

  const confirm = async (confirmed = false) => {
    if (!confirmed && / \d+/.test(street)) {
      setNextConfirm(true)
      return
    }

    if (!street) {
      props.addNotification({
        color: 'warning',
        message: 'Straße fehlt!',
      })

      return
    }

    if (!house) {
      props.addNotification({
        color: 'warning',
        message: 'Hausnummer fehlt!',
      })

      return
    }

    if (zipCode.length !== 4) {
      props.addNotification({
        color: 'warning',
        message: 'Postleitzahl prüfen!',
      })
      return
    }

    if (city.length < 2) {
      props.addNotification({
        color: 'warning',
        message: 'Stadt prüfen!',
      })
      return
    }

    setShowLoading(true);

    await props.setAddress({
      riskAddress: {
        gstnr
      },
      street,
      house,
      stairs,
      door,
      zipCode,
      city,
    })

    setShowLoading(false)

    props.history.push({ pathname: '/building' })
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/home' })}>
              <IonIcon slot="icon-only" icon={home} />
            </IonButton>
          </IonButtons>
          <IonTitle>Eigenheim Versicherung</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Verarbeite...'}
        />

        <EigenheimSteps current={1}/>

        <Note>
          Wir benötigen ihre Adresse um ein Angebot erstellen zu können.
        </Note>

        <IonItemGroup style={{marginTop: 16, marginLeft: -16, marginRight: -16}}>
          <IonItemDivider>
            <IonLabel>Adresse</IonLabel>
          </IonItemDivider>
          <IonItem>
            <IonLabel position="floating">Grundstücksnummer</IonLabel>
            <IonInput value={gstnr} onIonChange={e => setGstnr((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">Straße</IonLabel>
            <IonInput value={street} onIonChange={e => setStreet((e.target as HTMLInputElement).value)} />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">Hausnummer</IonLabel>
            <IonInput value={house} onIonChange={e => setHouse((e.target as HTMLInputElement).value)} />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">Stiege</IonLabel>
            <IonInput value={stairs} onIonChange={e => setStairs((e.target as HTMLInputElement).value)} />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">Türe</IonLabel>
            <IonInput value={door} onIonChange={e => setDoor((e.target as HTMLInputElement).value)} />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">PLZ</IonLabel>
            <IonInput value={zipCode} onIonChange={e => setZipCode((e.target as HTMLInputElement).value)} />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">Ort</IonLabel>
            <IonInput value={city} onIonChange={e => setCity((e.target as HTMLInputElement).value)} />
          </IonItem>
        </IonItemGroup>

        <Note>
          In der Zusammenfassung erhalten sie eine Vollständige Übersicht über die Leistungen.
        </Note>


        <IonAlert
          isOpen={nextConfirm}
          onDidDismiss={() => setNextConfirm(false)}
          header={'Straße enthält Hausnummer'}
          subHeader={'Hausnummer muss in das Separate Feld eingetragen werden.'}
          buttons={[
            'ok',
          ]}
        />

      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/person'})}>
              Zurück
            </IonButton>
          </IonButtons>
          <IonButton color="primary" expand={'block'} onClick={() => confirm()}>weiter</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default connect<StateProps, DispatchProps, unknown, State>(
  ({scan, quote}: any) => {
    return {
      decoded: scan.decoded,
      address: quote.address,
    }
  },
  {
    setAddress,
    addNotification,
  }
)(Address);
